
import { api } from './api';

interface CheckoutResponse {
    authorization_url: string;
    access_code: string;
    reference: string;
}

export const createCheckoutSession = (
    planCode: string | null, 
    amount: number, 
    type: 'subscription' | 'credit' = 'subscription', 
    creditAmount?: number
): Promise<CheckoutResponse> => {
    return api.post('/billing/create-checkout-session', { planCode, amount, type, creditAmount });
};

interface PortalSessionResponse {
    manage_link: string;
}

export const createPortalSession = (): Promise<PortalSessionResponse> => {
    return api.post('/billing/create-portal-session', {});
};
